module.exports = __webpack_public_path__ + "static/media/waveTop.c8e9caed.svg";